import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import ReactComponent from '@/components/ReactComponent';
import { MEIO_JULGAMENTO_SESSAO } from '@/dominio/MeioJulgamentoSessao';
import TipoRemessaJulgamentoProcesso from '@/dominio/TipoRemessaJulgamentoProcesso';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import DetalheRemessaJulgamento from '../DetalheRemessaJulgamento';
import IconeTipoRemessaJulgamentoFormRemessa from './IconeTipoRemessaJulgamentoFormRemessa';

class IconeTipoRemessaJulgamento extends ReactComponent {
    /** @type {object} */
    anchorEl = null;

    /** @type {object} */
    anchorElMenuItem = null;

    /** @type {boolean} */
    openMenu = Boolean(this.anchorEl);

    /** @type {boolean} */
    openEdicaoRemessa = false;

    /** @type {boolean} */
    openVisualizadorMotivoRemessa = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            anchorEl: observable,
            anchorElMenuItem: observable,
            openMenu: observable,
            openEdicaoRemessa: observable,
            openVisualizadorMotivoRemessa: observable,
            idPopoverEdicaoRemessa: computed,
            registro: computed,
            processo: computed,
            sessaoSemPeriodoVirtualDefinido: computed,
            sessaoIdAssociada: computed,
            tooltipRemessa: computed,
            labelChip: computed,
            handleClickMenuRemessa: action,
            handleCloseMenuRemessa: action,
            handleCloseMenuItem: action,
            handleCloseConfirmacaoExclusao: action,
            abrirVisualizadorMotivoRemessa: action,
            handleCloseVisualizadorMotivoRemessa: action,
            abrirEdicaoRemessa: action,
            meioJulgamentoSessao: computed,
            pautaExclusivamenteVirtual: computed,
            carregarDetalhesRemessa: action,
            sessaoSelecionada: computed,
            isSessaoFinalizada: computed
        });
    }

    get idPopoverEdicaoRemessa() {
        return this.openEdicaoRemessa ? 'popover-edicao-remessa' : undefined;
    }

    get registro() {
        return this.observableProps.registro;
    }

    get processo() {
        return this.registro.processo;
    }

    get sessaoSemPeriodoVirtualDefinido() {
        return (
            !this.sessaoSelecionada?.prazosPorSessao ||
            !this.sessaoIdAssociada ||
            !this.sessaoSelecionada.prazosPorSessao[this.sessaoIdAssociada]?.temPrazoDeVotacaoVirtual
        );
    }

    get sessaoIdAssociada() {
        if (this.registro?.sessaoId) {
            return this.registro.sessaoId;
        }

        // Para processos disponíveis, não há sessão cadastrada no processo, utilizar a selecionada na combo de pauta
        return this.pautaJulgamentoStore?.idPautaSelecionada;
    }

    get tooltipRemessa() {
        const descricaoRemessa = TipoRemessaJulgamentoProcesso.getDescricao(this.registro?.remessaJulgamento?.tipo?.id);
        return <Typography>{descricaoRemessa}</Typography>;
    }

    get labelChip() {
        return this.registro?.remessaJulgamento?.tipo?.id;
    }

    handleClickMenuRemessa = (event) => {
        this.anchorEl = event.currentTarget;
        this.anchorElMenuItem = this.anchorEl;
        this.openMenu = true;
    };

    handleCloseMenuRemessa = () => {
        this.anchorEl = null;
        this.openMenu = false;
    };

    handleCloseMenuItem = () => {
        this.openEdicaoRemessa = false;
        this.openVisualizadorMotivoRemessa = false;
        this.exclusaoConfirmada = false;
    };

    handleCloseConfirmacaoExclusao = () => {
        this.exclusaoConfirmada = false;
        this.openConfirmacaoExclusaoRemessa = false;
    };

    abrirVisualizadorMotivoRemessa = async () => {
        this.openMenu = false;
        this.openVisualizadorMotivoRemessa = true;
        await this.carregarDetalhesRemessa();
    };

    handleCloseVisualizadorMotivoRemessa = () => {
        this.openVisualizadorMotivoRemessa = false;
    };

    abrirEdicaoRemessa = () => {
        this.openMenu = false;
        this.openEdicaoRemessa = true;
    };

    get meioJulgamentoSessao() {
        if (this.sessaoSelecionada?.tipoJulgamento) {
            return this.sessaoSelecionada?.tipoJulgamento;
        }

        return '';
    }

    get pautaExclusivamenteVirtual() {
        return this.meioJulgamentoSessao === MEIO_JULGAMENTO_SESSAO.VIRTUAL.codigo;
    }

    renderDialogVisualizadorMotivoRemessa() {
        return (
            <Dialog
                open={this.openVisualizadorMotivoRemessa}
                onClose={this.handleCloseVisualizadorMotivoRemessa}
                maxWidth="xl"
            >
                <DialogTitle sx={{ m: 1 }}>
                    <Typography fontWeight={'bold'}>Detalhes da remessa</Typography>
                </DialogTitle>
                <DialogContent sx={{ m: 1 }}>
                    <DetalheRemessaJulgamento registro={this.registro} />
                </DialogContent>
                <DialogActions sx={{ mr: 3, mb: 1 }}>
                    <Button
                        color="primary"
                        size="medium"
                        variant="contained"
                        endIcon={<CloseIcon />}
                        onClick={this.handleCloseVisualizadorMotivoRemessa}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    carregarDetalhesRemessa = async () => {
        console.log(`Carregando detalhes da remessa do processo ${this.processo.numeroCompleto}...`);
    };

    get sessaoSelecionada() {
        return this.sessaoStore.sessaoSelecionada;
    }

    get isSessaoFinalizada() {
        return this.sessaoStore.isSessaoFinalizada;
    }

    render() {
        if (!this.registro?.remessaJulgamento?.tipo?.id) {
            return null;
        }

        const menuId = 'remessa-julgamento-menu';

        return (
            <>
                <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                    <Tooltip title={this.tooltipRemessa}>
                        <Box
                            onClick={this.handleClickMenuRemessa}
                            aria-controls={this.openMenu ? menuId : undefined}
                            aria-haspopup="true"
                            aria-expanded={this.openMenu ? 'true' : undefined}
                        >
                            {TipoRemessaJulgamentoProcesso.getIcone(this.registro?.remessaJulgamento?.tipo?.id)}
                        </Box>
                    </Tooltip>
                </Box>
                <Menu
                    anchorEl={this.anchorEl}
                    id={menuId}
                    open={this.openMenu}
                    onClose={this.handleCloseMenuRemessa}
                    onClick={this.handleCloseMenuRemessa}
                    slotProps={{
                        paper: {
                            elevation: 0,
                            sx: {
                                overflow: 'visible',
                                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                mt: 1.5,
                                '& .MuiChip-root': {
                                    width: 24,
                                    height: 24,
                                    ml: -0.5,
                                    mr: 1
                                },
                                '&::before': {
                                    content: '""',
                                    display: 'block',
                                    position: 'absolute',
                                    top: 0,
                                    left: 13,
                                    width: 15,
                                    height: 15,
                                    bgcolor: 'background.paper',
                                    transform: 'translateY(-50%) rotate(45deg)',
                                    zIndex: 0
                                }
                            }
                        }
                    }}
                    transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                >
                    <MenuItem onClick={this.abrirVisualizadorMotivoRemessa}>
                        <ListItemIcon>
                            <WysiwygIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography fontSize="small">Visualizar detalhes da remessa</Typography>
                        </ListItemText>
                    </MenuItem>
                    <MenuItem onClick={this.abrirEdicaoRemessa}>
                        <ListItemIcon>
                            <EditIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography fontSize="small">Alterar remessa</Typography>
                        </ListItemText>
                    </MenuItem>
                </Menu>
                {this.openVisualizadorMotivoRemessa && this.renderDialogVisualizadorMotivoRemessa()}
                {this.openEdicaoRemessa && (
                    <Popover
                        id={this.idPopoverEdicaoRemessa}
                        open={this.openEdicaoRemessa}
                        anchorEl={this.anchorElMenuItem}
                        onClose={this.handleCloseMenuItem}
                        sx={{
                            maxWidth: 'xl'
                        }}
                    >
                        <IconeTipoRemessaJulgamentoFormRemessa
                            registro={this.registro}
                            onClose={this.handleCloseMenuItem}
                        />
                    </Popover>
                )}
            </>
        );
    }
}

export default inject('stores')(observer(IconeTipoRemessaJulgamento));
